(function () {
  angular
    .module("app")
    .factory("netSuite", ["$http", "$q", function ($http, $q) {
      function getBilling() {
        var deferred = $q.defer();

        $http.get("/api/ManageAccount/GetBillingInformation").success(function (response) {

          var billing = {
            hasBillingInformation: response.HasBillingInformation,
            address1: response.Address1,
            address2: response.Address2,
            city: response.City,
            state: response.State,
            postalCode: response.Zip,
            country: response.Country,
            phoneNumber: response.PhoneNumber
          };

          deferred.resolve(billing);

        }).error(function (err) {
          deferred.reject(err);
        });

        return deferred.promise;
      }

      function getCredit() {
        var deferred = $q.defer();

        $http.get("/api/ManageAccount/GetCreditInformation").success(function (response) {

          var credit = {
            hasCreditInformation: response.HasCreditInformation,
            name: response.CardName,
            expYear: response.CardExpYear,
            expMonth: response.CardExpMonth,
            type: response.CardType,
            number: response.CardLastDigits
          };

          deferred.resolve(credit);

        }).error(function (err) {
          deferred.reject(err);
        });

        return deferred.promise;
      }

      function getPaymentInformation() {
        var deferred = $q.defer();

        $http.get("/api/ManageAccount/GetPaymentInformation").success(function (response) {

          deferred.resolve(response);

        }).error(function (err) {
          deferred.reject(err);
        });

        return deferred.promise;
      }

      return {
        getPaymentInformation: getPaymentInformation
      };
    }]);
})();




// WEBPACK FOOTER //
// ./app/account/netSuite.service.js